/*
 * Appearance: react-time-picker ships its own stylesheet (imported alongside
 * this one) that hardcodes a light palette - `white` on the clock popup,
 * `#f0f0f0`/`#6d6d6d` on the disabled state - and leaves the input and the
 * AM/PM <select> to the browser's default black. None of that is reachable
 * from a React Native StyleSheet, so the overrides live here and read the same
 * CSS variables the role tokens generate.
 */
.gripp-time-picker {
  width: 100%;
  font-family: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  padding-left: 8px;
  color: var(--text-strong);
}

.gripp-time-picker input,
.gripp-time-picker select {
  color: var(--text-strong);
}

/* Native dropdown list: the popup is UA-painted, so it needs both. */
.gripp-time-picker select option {
  background-color: var(--surface);
  color: var(--text-strong);
}

.gripp-time-picker .react-time-picker__inputGroup__divider,
.gripp-time-picker .react-time-picker__inputGroup__leadingZero {
  color: var(--text-strong);
}

.gripp-time-picker.react-time-picker--disabled,
.gripp-time-picker .react-time-picker--disabled {
  background-color: var(--input-background);
  color: var(--text-disabled);
}

.gripp-time-picker .react-time-picker__clock {
  background-color: var(--surface);
  border-color: var(--border-control);
}

.gripp-time-picker .react-time-picker__wrapper {
  border: none;
  background: transparent;
}

.gripp-time-picker .react-time-picker__inputGroup {
  font-size: 16px;
}
.gripp-time-picker .react-time-picker__inputGroup__amPm {
  font-size: 16px;
  font-weight: 400;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  background: transparent;
  outline: none;
  cursor: pointer;
  padding: 0;
  margin-left: 6px;
}

.gripp-time-picker .react-time-picker__inputGroup {
  display: flex;
  align-items: center;
}
.gripp-time-picker .react-time-picker__inputGroup__leadingZero + input {
  min-width: 1ch !important;
  width: 1ch !important;
}
.gripp-time-picker .react-time-picker__inputGroup__divider:has(+ select) {
  display: none;
}
